"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[659],{

/***/ 50659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tw": function() { return /* reexport */ testimonial_Director; }
});

// UNUSED EXPORTS: Testimonial1, Testimonial10, Testimonial11, Testimonial12, Testimonial13, Testimonial14, Testimonial15, Testimonial16, Testimonial17, Testimonial18, Testimonial19, Testimonial2, Testimonial20, Testimonial21, Testimonial3, Testimonial5, Testimonial6, Testimonial7, Testimonial8, Testimonial9

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/reuseable/links/NextLink.tsx
var links_NextLink = __webpack_require__(99472);
;// CONCATENATED MODULE: ./src/components/reuseable/testimonial-cards/TestimonialCard1.tsx

// =================================================
var TestimonialCard1_TestimonialCard1 = function(props) {
    var name = props.name, review = props.review, designation = props.designation;
    return /*#__PURE__*/ _jsx("div", {
        className: "card shadow-lg",
        children: /*#__PURE__*/ _jsx("div", {
            className: "card-body",
            children: /*#__PURE__*/ _jsxs("blockquote", {
                className: "icon mb-0",
                children: [
                    /*#__PURE__*/ _jsxs("p", {
                        children: [
                            "“",
                            review,
                            "”"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "blockquote-details",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "info p-0",
                            children: [
                                /*#__PURE__*/ _jsx("h5", {
                                    className: "mb-1",
                                    children: name
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "mb-0",
                                    children: designation
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var testimonial_cards_TestimonialCard1 = ((/* unused pure expression or super */ null && (TestimonialCard1_TestimonialCard1)));

;// CONCATENATED MODULE: ./src/components/reuseable/testimonial-cards/TestimonialCard2.tsx

// =================================================
var TestimonialCard2_TestimonialCard2 = function(props) {
    var name = props.name, review = props.review, designation = props.designation, blockClassName = props.blockClassName, blockDetailsClassName = props.blockDetailsClassName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
        className: blockClassName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "“",
                    review,
                    "”"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: blockDetailsClassName,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "info ps-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            className: "mb-1",
                            children: name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-0",
                            children: designation
                        })
                    ]
                })
            })
        ]
    });
};
// set default props
TestimonialCard2_TestimonialCard2.defaultProps = {
    blockClassName: "icon icon-top fs-lg text-center",
    blockDetailsClassName: "blockquote-details justify-content-center text-center"
};
/* harmony default export */ var testimonial_cards_TestimonialCard2 = ((/* unused pure expression or super */ null && (TestimonialCard2_TestimonialCard2)));

;// CONCATENATED MODULE: ./src/components/reuseable/testimonial-cards/TestimonialCard3.tsx

// =================================================
var TestimonialCard3 = function(props) {
    var name = props.name, image = props.image, review = props.review, designation = props.designation, alt = props.alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card shadow-none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                className: "w-100 overflow-hidden mb-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    width: 100,
                    height: 29,
                    src: image,
                    alt: alt,
                    style: {
                        background: "transparent"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card-body",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                    className: "icon mb-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "“",
                                review,
                                "”"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "blockquote-details",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "info",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: "mb-0",
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-0",
                                        children: designation
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var testimonial_cards_TestimonialCard3 = (TestimonialCard3);

// EXTERNAL MODULE: ./src/components/reuseable/Carousel.tsx
var reuseable_Carousel = __webpack_require__(77632);
;// CONCATENATED MODULE: ./src/data/testimonial-list.ts
// used in the testimonial-1 block
var testimonial_list_testimonialList1 = [
    {
        id: "0",
        name: "Coriss Ambady",
        designation: "Financial Analyst",
        review: "Cum sociis natoque penatibus et magnis dis parturient montes.",
        image: "/img/photos/sp1.jpg",
        columnClasses: "col-xl-5 align-self-end"
    },
    {
        id: "1",
        name: "Coriss Ambady",
        designation: "Financial Analyst",
        review: "Cum sociis natoque penatibus et magnis dis parturient montes.",
        image: "/img/photos/sp1.jpg",
        columnClasses: "col-xl-5 align-self-end"
    }
];
var testimonial_list_testimonialList2 = [
    {
        "image": "/img/clients/testimonials/itv.png",
        "alt": "Web Development",
        "review": "Conscientious... flexible and relaxed, difficult to fluster and real drive to deliver... great value for money.",
        "name": "Paul Clark",
        "designation": "Controller, ITV Online Pay & Interactive"
    },
    {
        "image": "/img/clients/testimonials/Hogarth-Worldwide.png",
        "alt": "Web Development",
        "review": "His creative and thorough thinking has not only brought great ideas to the table but ultimately saved us time and money.",
        "name": "Gabriela Martinez-Campbell",
        "designation": "Account Director, Hogarth/Today at Apple"
    },
    {
        "image": "/img/clients/testimonials/bbc.png",
        "alt": "Web Development",
        "review": "Committed to delivery, good at client liaison, charges reasonable rates and tailors suggestions to the budget available. We wouldn't hesitate to use him again.",
        "name": "Mark Harisson",
        "designation": "Director of Technology Futures Group, BBC Engineering"
    },
    {
        "image": "/img/clients/testimonials/pegasus-medical.png",
        "alt": "Web Development",
        "review": "Reliable and excellent resource, instantly instrumental in large complex projects with an extremely quick turn around... patient, flexible and understood our requirements. I'd look forward to working with him again.",
        "name": "Kat Thay",
        "designation": "Pegasus Medical"
    },
    {
        "image": "/img/clients/testimonials/the-marketing-store.png",
        "alt": "Web Development",
        "review": "James is an outstanding and versatile developer with a wealth of experience across multiple FE technologies. He is able to quickly grasp project requirements and propose solution options whenever I have worked with him. Highly recommended.",
        "name": "Dimith De Alwis",
        "designation": "The Marketing Store"
    }, 
];
// used in the testimonial-13 block
var testimonial_list_testimonialList3 = [
    {
        id: 1,
        name: "Coriss Ambady",
        image: "/img/avatars/te1.jpg",
        designation: "Financial Analyst",
        review: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Vestibulum ligula porta\n    felis euismod semper. Cras justo odio consectetur adipiscing dapibus."
    },
    {
        id: 2,
        name: "Cory Zamora",
        image: "/img/avatars/te2.jpg",
        designation: "Marketing Specialist",
        review: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Vestibulum ligula porta\n    felis euismod semper. Cras justo odio consectetur adipiscing dapibus."
    },
    {
        id: 3,
        name: "Barclay Widerski",
        image: "/img/avatars/te3.jpg",
        designation: "Sales Specialist",
        review: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Vestibulum ligula porta\n    felis euismod semper. Cras justo odio consectetur adipiscing dapibus."
    }
];
// used in the testimonial-14, testimonial-15 block
var testimonial_list_testimonialList4 = [
    {
        id: 1,
        name: "Coriss Ambady",
        designation: "Financial Analyst",
        review: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Vestibulum id ligula porta. Cras mattis consectetur."
    },
    {
        id: 2,
        name: "Cory Zamora",
        designation: "Marketing Specialist",
        review: "Fusce dapibus, tellus ac cursus tortor mauris condimentum fermentum massa justo sit amet purus fermentum."
    },
    {
        id: 3,
        name: "Nikolas Brooten",
        designation: "Sales Manager",
        review: "Curabitur blandit tempus porttitor. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor eu rutrum. Nulla vitae libero."
    },
    {
        id: 4,
        name: "Coriss Ambady",
        designation: "Marketing Manager",
        review: "Etiam adipiscing tincidunt elit convallis felis suscipit ut. Phasellus rhoncus eu tincidunt auctor nullam rutrum."
    }
];
// used in the testimonial-16 block
var testimonial_list_testimonialList5 = [
    {
        id: 1,
        name: "Coriss Ambady",
        designation: "Financial Analyst",
        review: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Vestibulum ligula porta felis\n    euismod semper. Cras justo odio."
    },
    {
        id: 2,
        name: "Cory Zamora",
        designation: "Marketing Specialist",
        review: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Vestibulum ligula porta felis\n    euismod semper. Cras justo odio."
    },
    {
        id: 3,
        name: "Nikolas Brooten",
        designation: "Sales Manager",
        review: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Vestibulum ligula porta felis\n    euismod semper. Cras justo odio."
    }
];
// used in the testimonial-18 block
var testimonial_list_testimonialList6 = [
    {
        id: 1,
        name: "Julia & David",
        review: "Fusce dapibus tellus ac cursus commodo, tortor mauris condimentum nibh fermentum massa, justo sit\n    amet vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Cras mattis consectetur\n    purus."
    },
    {
        id: 2,
        name: "Jolene & Andrea",
        review: "Fusce dapibus tellus ac cursus commodo, tortor mauris condimentum nibh fermentum massa, justo sit\n    amet vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Cras mattis consectetur\n    purus."
    },
    {
        id: 3,
        name: "Eve & Will",
        review: "Fusce dapibus tellus ac cursus commodo, tortor mauris condimentum nibh fermentum massa, justo sit\n    amet vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Cras mattis consectetur\n    purus."
    }
];
// used in the testimonial-19 block
var testimonial_list_testimonialList7 = [
    {
        id: 1,
        name: "Coriss Ambady",
        designation: "Financial Analyst",
        review: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Vestibulum ligula porta felis euismod semper. Cras justo odio."
    },
    {
        id: 2,
        name: "Cory Zamora",
        designation: "Marketing Specialist",
        review: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Vestibulum ligula porta felis euismod semper. Cras justo odio."
    },
    {
        id: 3,
        name: "Nikolas Brooten",
        designation: "Sales Specialist",
        review: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Vestibulum ligula porta felis euismod semper. Cras justo odio."
    },
    {
        id: 4,
        name: "Jackie Sanders",
        designation: "Investment Planner",
        review: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Vestibulum ligula porta felis euismod semper. Cras justo odio."
    },
    {
        id: 5,
        name: "Laura Widerski",
        designation: "Sales Specialist",
        review: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Vestibulum ligula porta felis euismod semper. Cras justo odio."
    }
];

;// CONCATENATED MODULE: ./src/components/reuseable/testimonial-cards/TestimonialCard4.tsx





// ============================================================
var TestimonialCard4_TestimonialCard4 = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _sliderWrapperClassname = param.sliderWrapperClassname, sliderWrapperClassname = _sliderWrapperClassname === void 0 ? "p-10 p-md-11 p-lg-13" : _sliderWrapperClassname;
    return /*#__PURE__*/ _jsx("div", {
        className: "card shadow-lg ".concat(className),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "row gx-0",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        backgroundImage: "url(/img/photos/tm1.jpg)"
                    },
                    className: "col-lg-6 image-wrapper bg-image bg-cover rounded-top rounded-lg-start"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-lg-6",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: sliderWrapperClassname,
                        children: /*#__PURE__*/ _jsx(Carousel, {
                            grabCursor: true,
                            slidesPerView: 1,
                            navigation: false,
                            className: "dots-closer",
                            children: testimonialList2.map(function(item, i) {
                                return /*#__PURE__*/ _jsx(TestimonialCard2, _object_spread({}, item), i);
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var testimonial_cards_TestimonialCard4 = ((/* unused pure expression or super */ null && (TestimonialCard4_TestimonialCard4)));

;// CONCATENATED MODULE: ./src/components/reuseable/testimonial-cards/TestimonialCard5.tsx

// =================================================
var TestimonialCard5_TestimonialCard5 = function(props) {
    var name = props.name, review = props.review, designation = props.designation, borderBottom = props.borderBottom;
    var className = "card shadow-lg ".concat(borderBottom ? "card-border-bottom border-soft-primary" : "");
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-body",
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: "ratings five mb-3"
                }),
                /*#__PURE__*/ _jsxs("blockquote", {
                    className: "icon mb-0",
                    children: [
                        /*#__PURE__*/ _jsxs("p", {
                            children: [
                                "“",
                                review,
                                "”"
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "blockquote-details",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "info ps-0",
                                children: [
                                    /*#__PURE__*/ _jsx("h5", {
                                        className: "mb-1",
                                        children: name
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "mb-0",
                                        children: designation
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var testimonial_cards_TestimonialCard5 = ((/* unused pure expression or super */ null && (TestimonialCard5_TestimonialCard5)));

;// CONCATENATED MODULE: ./src/components/reuseable/testimonial-cards/TestimonialCard6.tsx

// =================================================
var TestimonialCard6_TestimonialCard6 = function(props) {
    var name = props.name, review = props.review, designation = props.designation;
    return /*#__PURE__*/ _jsx("div", {
        className: "card shadow-lg card-border-bottom border-soft-primary",
        children: /*#__PURE__*/ _jsx("div", {
            className: "card-body",
            children: /*#__PURE__*/ _jsxs("blockquote", {
                className: "border-0 mb-0",
                children: [
                    /*#__PURE__*/ _jsxs("p", {
                        children: [
                            "“",
                            review,
                            "”"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "blockquote-details",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "info ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("h5", {
                                    className: "mb-1",
                                    children: name
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "mb-0",
                                    children: designation
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var testimonial_cards_TestimonialCard6 = ((/* unused pure expression or super */ null && (TestimonialCard6_TestimonialCard6)));

;// CONCATENATED MODULE: ./src/components/reuseable/testimonial-cards/index.ts








;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Testimonial1.tsx




// -------- data -------- //

var Testimonial1 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-gradient-reverse-primary",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container py-14 py-md-18",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gx-lg-8 gx-xl-12 gy-10 align-items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-7",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "row gx-md-5 gy-5",
                            children: testimonialList1.map(function(item, i) {
                                return /*#__PURE__*/ _jsx("div", {
                                    className: "col-md-6 ".concat(item.columnClasses),
                                    children: /*#__PURE__*/ _jsx(TestimonialCard1, _object_spread({}, item))
                                }, i);
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-5",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "fs-16 text-uppercase text-muted mb-3 mt-lg-n6",
                                children: "Our Community"
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-4 mb-5",
                                children: "Don't take our word for it. See what customers are saying about us."
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: "Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Nulla vitae elit libero, a pharetra augue. Maecenas faucibus mollis interdum. Vestibulum id ligula porta felis euismod."
                            }),
                            /*#__PURE__*/ _jsx(NextLink, {
                                href: "#",
                                title: "All Testimonials",
                                className: "btn btn-primary rounded-pill mt-3"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var testimonial_Testimonial1 = ((/* unused pure expression or super */ null && (Testimonial1)));

;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Testimonial2.tsx


var Testimonial2 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "position-relative mt-n18 mt-md-n23 mb-16 mb-md-18",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "shape rounded-circle bg-line primary rellax w-18 h-18",
                style: {
                    zIndex: 0,
                    top: "-2rem",
                    right: "-2.7rem"
                }
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "shape rounded-circle bg-soft-primary rellax w-18 h-18",
                style: {
                    zIndex: 0,
                    left: "-3rem",
                    bottom: "-1rem"
                }
            }),
            /*#__PURE__*/ _jsx(TestimonialCard4, {})
        ]
    });
};
/* harmony default export */ var testimonial_Testimonial2 = ((/* unused pure expression or super */ null && (Testimonial2)));

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/elements/tiles/index.tsx + 11 modules
var tiles = __webpack_require__(27492);
;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Testimonial3.tsx






// -------- data -------- //

var Testimonial3 = function() {
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "display-4 mb-3 text-center",
                children: "What People Say About Us"
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "lead fs-lg mb-10 text-center",
                children: "Dont take our word for it. See what customers are saying about us."
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-lg-8 gx-xl-12 gy-6 mb-14 align-items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-7",
                        children: /*#__PURE__*/ _jsx(Tiles3, {})
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-5 mt-5",
                        children: /*#__PURE__*/ _jsx(Carousel, {
                            grabCursor: true,
                            slidesPerView: 1,
                            navigation: false,
                            children: testimonialList2.map(function(item, i) {
                                return /*#__PURE__*/ _jsx(TestimonialCard2, _object_spread({}, item), i);
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var testimonial_Testimonial3 = ((/* unused pure expression or super */ null && (Testimonial3)));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var src_object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/utils/carouselBreakpoints.ts
var utils_carouselBreakpoints = __webpack_require__(32783);
;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Director.tsx







// -------- data -------- //

var Director = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "wrapper bg-light",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container-fluid py-8 pt-md-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "wrapper image-wrapper ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row gx-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-10 offset-1 col-md-8 offset-md-2 col-xl-6 offset-xl-3 mx-auto text-center pb-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "fs-15 text-uppercase text-muted mb-3",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "display-4 mb-6 px-xl-10 px-xxl-15",
                                    children: "James Finlayson, Director"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-md-flex justify-content-md-center align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mobile-12",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "rounded-circle border-dark overflow-hidden bg-overlay bg-overlay-light-500 mt-2 mb-5",
                                                style: {
                                                    backgroundImage: "url(/img/photos/bg22s.jpg)",
                                                    backgroundSize: "210px 216px",
                                                    width: "150px",
                                                    height: "150px"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    width: "97%",
                                                    height: "100%",
                                                    src: "/img/director/jamie.png",
                                                    alt: "technical SEO consultants",
                                                    style: {
                                                        background: "transparent"
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "d-block ms-md-5 mobile-12",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "James has lead development teams for the largest tech companies in the world. Here are some of the things his clients have said about\xa0him."
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container pb-15 pb-md-12 carousel-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(reuseable_Carousel/* default */.Z, {
                        grabCursor: true,
                        className: "p-2",
                        navigation: false,
                        breakpoints: utils_carouselBreakpoints/* default */.Z,
                        children: testimonial_list_testimonialList2.map(function(item, i) {
                            return /*#__PURE__*/ (0,react.createElement)(testimonial_cards_TestimonialCard3, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
                                key: i
                            }));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "seo-audit"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var testimonial_Director = (Director);

;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Testimonial5.tsx






// -------- data -------- //

var Testimonial5 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-soft-primary",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container pt-16 pb-14 pb-md-0",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gx-lg-8 gx-xl-0 align-items-center",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-md-5 col-lg-5 col-xl-4 offset-xl-1 d-none d-md-flex position-relative align-self-end",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "shape rounded-circle bg-pale-primary rellax w-21 h-21 d-md-none d-lg-block",
                                style: {
                                    top: "7rem",
                                    left: "1rem"
                                }
                            }),
                            /*#__PURE__*/ _jsx("figure", {
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: "/img/photos/co1.png",
                                    srcSet: "/img/photos/co1@2x.png 2x",
                                    alt: ""
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-7 col-lg-6 col-xl-6 col-xxl-5 offset-xl-1",
                        children: /*#__PURE__*/ _jsx(Carousel, {
                            grabCursor: true,
                            slidesPerView: 1,
                            navigation: false,
                            className: "dots-start",
                            children: testimonialList2.map(function(item, i) {
                                return /*#__PURE__*/ _createElement(TestimonialCard2, _object_spread_props(_object_spread({}, item), {
                                    key: i,
                                    blockClassName: "icon fs-lg",
                                    blockDetailsClassName: "blockquote-details"
                                }));
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var testimonial_Testimonial5 = ((/* unused pure expression or super */ null && (Testimonial5)));

;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Testimonial6.tsx

var Testimonial6 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "card bg-soft-primary",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-body p-md-10 py-xxl-16 position-relative",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "position-absolute d-none d-lg-block",
                    style: {
                        bottom: 0,
                        left: "10%",
                        width: "28%",
                        zIndex: 2
                    },
                    children: /*#__PURE__*/ _jsx("figure", {
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/img/photos/co2.png",
                            srcSet: "/img/photos/co2@2x.png 2x",
                            alt: "coriss"
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row gx-md-0 gx-xl-12 text-center",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-7 offset-lg-5 col-xl-6",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "ratings five mb-3"
                            }),
                            /*#__PURE__*/ _jsxs("blockquote", {
                                className: "border-0 fs-lg mb-0",
                                children: [
                                    /*#__PURE__*/ _jsx("p", {
                                        children: "“Fusce dapibus tellus ac cursus commodo, tortor mauris condimentum nibh ut fermentum massa, justo sit amet vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Cras mattis consectetur purus sit amet fermentum. Aenean lacinia bibendum nulla sed”"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "blockquote-details justify-content-center text-center",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "info p-0",
                                            children: [
                                                /*#__PURE__*/ _jsx("h5", {
                                                    className: "mb-1",
                                                    children: "Coriss Ambady"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "meta mb-0",
                                                    children: "Financial Analyst"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var testimonial_Testimonial6 = ((/* unused pure expression or super */ null && (Testimonial6)));

;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Testimonial7.tsx





// -------- data -------- //

var Testimonial7 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-lg-8 gx-xl-12 gy-6 mb-14 align-items-center",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "col-lg-7 position-relative",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "shape bg-dot primary rellax w-18 h-18",
                        style: {
                            top: 0,
                            left: "-1.4rem",
                            zIndex: 0
                        }
                    }),
                    /*#__PURE__*/ _jsx(Tiles3, {})
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-lg-5 mt-5",
                children: /*#__PURE__*/ _jsx(Carousel, {
                    grabCursor: true,
                    slidesPerView: 1,
                    navigation: false,
                    children: testimonialList2.map(function(item, i) {
                        return /*#__PURE__*/ _jsx(TestimonialCard2, _object_spread({}, item), i);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var testimonial_Testimonial7 = ((/* unused pure expression or super */ null && (Testimonial7)));

// EXTERNAL MODULE: ./src/hooks/useIsotope.ts
var hooks_useIsotope = __webpack_require__(80959);
;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Testimonial8.tsx

// -------- custom hook -------- //

var Testimonial8 = function() {
    // used for masonry layout
    useIsotope();
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "display-4 text-center mb-8",
                children: "Happy Customers"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "grid",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "row isotope gy-6"
                })
            })
        ]
    });
};
/* harmony default export */ var testimonial_Testimonial8 = ((/* unused pure expression or super */ null && (Testimonial8)));

;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Testimonial9.tsx

var Testimonial9 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "card bg-soft-primary rounded-4 mb-14 mb-md-18",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-body p-md-10 py-xxl-16 position-relative",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "position-absolute d-none d-lg-block",
                    style: {
                        bottom: 0,
                        left: "10%",
                        width: "28%",
                        zIndex: 2
                    },
                    children: /*#__PURE__*/ _jsx("figure", {
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/img/photos/co2.png",
                            srcSet: "/img/photos/co2@2x.png 2x",
                            alt: ""
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row gx-md-0 gx-xl-12 text-center",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-7 offset-lg-5 col-xl-6",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "ratings five mb-3"
                            }),
                            /*#__PURE__*/ _jsxs("blockquote", {
                                className: "border-0 fs-lg mb-0",
                                children: [
                                    /*#__PURE__*/ _jsx("p", {
                                        children: "“Fusce dapibus tellus ac cursus commodo, tortor mauris condimentum nibh ut fermentum massa, justo sit amet vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Cras mattis consectetur purus sit amet fermentum. Aenean lacinia bibendum nulla sed”"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "blockquote-details justify-content-center text-center",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "info p-0",
                                            children: [
                                                /*#__PURE__*/ _jsx("h5", {
                                                    className: "mb-1",
                                                    children: "Coriss Ambady"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "meta mb-0",
                                                    children: "Financial Analyst"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var testimonial_Testimonial9 = ((/* unused pure expression or super */ null && (Testimonial9)));

;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Testimonial10.tsx

// -------- custom hook -------- //

var Testimonial10 = function() {
    // used for masonry layout
    useIsotope();
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-soft-primary",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container py-14 py-md-17",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "row mt-md-n25",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-md-10 offset-md-1 col-lg-8 offset-lg-2 mx-auto text-center",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "fs-15 text-uppercase text-muted mb-3",
                                children: "Happy Customers"
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-4 mb-10 px-xl-10 px-xxl-15",
                                children: "Don't take our word for it. See what customers are saying about us."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "grid",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "row isotope gy-6"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var testimonial_Testimonial10 = ((/* unused pure expression or super */ null && (Testimonial10)));

// EXTERNAL MODULE: ./src/data/demo-11.ts
var demo_11 = __webpack_require__(29190);
;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Testimonial11.tsx


// -------- data -------- //

var Testimonial11 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "row mt-md-n50p text-white text-center",
        children: /*#__PURE__*/ _jsx("div", {
            className: "col-xl-10 mx-auto mb-14 mb-lg-n6",
            children: /*#__PURE__*/ _jsx("div", {
                className: "card image-wrapper bg-full bg-image bg-overlay bg-overlay-400",
                style: {
                    backgroundImage: "url(/img/photos/bg2.jpg)"
                },
                children: /*#__PURE__*/ _jsx("div", {
                    className: "card-body p-9 p-xl-12",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "row gx-0",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "col-xxl-9 mx-auto",
                            children: /*#__PURE__*/ _jsx(Carousel, {
                                navigation: false,
                                slidesPerView: 1,
                                className: "dots-light dots-closer",
                                children: testimonialList.map(function(item) {
                                    return /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "ratings five mb-3"
                                            }),
                                            /*#__PURE__*/ _jsxs("blockquote", {
                                                className: "border-0 fs-lg mb-2",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("p", {
                                                        children: [
                                                            "“",
                                                            item.review,
                                                            "”"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "blockquote-details justify-content-center text-center",
                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                            className: "info ps-0",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("h5", {
                                                                    className: "mb-1 text-white",
                                                                    children: item.name
                                                                }),
                                                                /*#__PURE__*/ _jsx("p", {
                                                                    className: "mb-0",
                                                                    children: item.designation
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, item.id);
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var testimonial_Testimonial11 = ((/* unused pure expression or super */ null && (Testimonial11)));

// EXTERNAL MODULE: ./src/data/demo-12.ts + 4 modules
var demo_12 = __webpack_require__(83152);
;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Testimonial12.tsx



// -------- data -------- //

var Testimonial12 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "grid mb-14 mb-md-18 mt-3",
        children: /*#__PURE__*/ _jsx("div", {
            className: "row isotope gy-6 mt-n19 mt-md-n22",
            children: reviews.map(function(item) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "item col-md-6 col-xl-3",
                    children: /*#__PURE__*/ _jsx(TestimonialCard5, _object_spread({
                        borderBottom: true
                    }, item))
                }, item.id);
            })
        })
    });
};
/* harmony default export */ var testimonial_Testimonial12 = ((/* unused pure expression or super */ null && (Testimonial12)));

// EXTERNAL MODULE: ./src/components/reuseable/FigureImage.tsx
var reuseable_FigureImage = __webpack_require__(42744);
;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Testimonial13.tsx



// -------- data -------- //

var Testimonial13 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper image-wrapper bg-image bg-overlay bg-overlay-300 text-white",
        style: {
            backgroundImage: "url(/img/photos/bg2.jpg)"
        },
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container py-14 py-md-17",
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "display-4 mb-5 text-white text-center",
                    children: "Happy Customers"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "col-md-10 col-lg-8 mx-auto",
                        children: /*#__PURE__*/ _jsx(Carousel, {
                            slidesPerView: 1,
                            navigation: false,
                            className: "dots-light dots-closer text-center",
                            grabCursor: true,
                            children: testimonialList3.map(function(param) {
                                var name = param.name, image = param.image, designation = param.designation, review = param.review, id = param.id;
                                return /*#__PURE__*/ _jsxs("blockquote", {
                                    className: "border-0 fs-lg mb-0",
                                    children: [
                                        /*#__PURE__*/ _jsxs("p", {
                                            children: [
                                                "“",
                                                review,
                                                "”"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "blockquote-details justify-content-center",
                                            children: [
                                                /*#__PURE__*/ _jsx(FigureImage, {
                                                    width: 100,
                                                    height: 100,
                                                    className: "rounded-circle w-12 overflow-hidden",
                                                    src: image
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "info",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("h6", {
                                                            className: "mb-1 text-white",
                                                            children: name
                                                        }),
                                                        /*#__PURE__*/ _jsx("p", {
                                                            className: "mb-0",
                                                            children: designation
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, id);
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var testimonial_Testimonial13 = ((/* unused pure expression or super */ null && (Testimonial13)));

;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Testimonial14.tsx



// -------- data -------- //

var Testimonial14 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "grid mb-14 mb-md-17",
        children: /*#__PURE__*/ _jsx("div", {
            className: "row isotope gy-6 mt-n19 mt-md-n22",
            children: testimonialList4.map(function(item) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "item col-md-6 col-xl-3",
                    children: /*#__PURE__*/ _jsx(TestimonialCard5, _object_spread({}, item))
                }, item.id);
            })
        })
    });
};
/* harmony default export */ var testimonial_Testimonial14 = ((/* unused pure expression or super */ null && (Testimonial14)));

;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Testimonial15.tsx



// -------- data -------- //

var Testimonial15_Testimonial14 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "grid mb-18",
        children: /*#__PURE__*/ _jsx("div", {
            className: "row isotope gy-6 mt-n18",
            children: testimonialList4.map(function(item) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "item col-md-6 col-xl-3",
                    children: /*#__PURE__*/ _jsx(TestimonialCard6, _object_spread({}, item))
                }, item.id);
            })
        })
    });
};
/* harmony default export */ var Testimonial15 = ((/* unused pure expression or super */ null && (Testimonial15_Testimonial14)));

;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Testimonial16.tsx


// -------- data-------- //

var Testimonial16 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "card shadow-lg mt-n21 mt-md-n23",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "row gx-0",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-lg-6 image-wrapper bg-image bg-cover rounded-top rounded-lg-start",
                    style: {
                        backgroundImage: "url(/img/photos/tm2.jpg)"
                    }
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-lg-6",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "p-10 p-md-11 px-lg-13 py-lg-14",
                        children: /*#__PURE__*/ _jsx(Carousel, {
                            slidesPerView: 1,
                            navigation: false,
                            className: "dots-closer",
                            children: testimonialList5.map(function(param) {
                                var id = param.id;
                                return /*#__PURE__*/ _jsxs("div", {
                                    className: "text-center",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "ratings five mt-4 mb-3"
                                        }),
                                        /*#__PURE__*/ _jsxs("blockquote", {
                                            className: "border-0 fs-lg text-center",
                                            children: [
                                                /*#__PURE__*/ _jsx("p", {
                                                    children: "“Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Vestibulum ligula porta felis euismod semper. Cras justo odio.”"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "blockquote-details justify-content-center text-center",
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        className: "info ps-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("h5", {
                                                                className: "mb-1",
                                                                children: "Cory Zamora"
                                                            }),
                                                            /*#__PURE__*/ _jsx("p", {
                                                                className: "mb-0",
                                                                children: "Marketing Specialist"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, id);
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var testimonial_Testimonial16 = ((/* unused pure expression or super */ null && (Testimonial16)));

;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Testimonial17.tsx

// -------- custom hook -------- //

var Testimonial17 = function() {
    // used for masonry grid layout
    useIsotope();
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-gradient-primary",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container pt-12 pt-lg-8 pb-14 pb-md-17",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "row text-center",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-8 offset-lg-2",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "fs-16 text-uppercase text-primary mb-3",
                                children: "Happy Customers"
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-3 mb-10 px-xxl-10",
                                children: "Don't take our word for it. See what customers are saying about us."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "grid",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "row isotope gy-6"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var testimonial_Testimonial17 = ((/* unused pure expression or super */ null && (Testimonial17)));

;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Testimonial18.tsx


// -------- data -------- //

var Testimonial18 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper image-wrapper bg-image bg-overlay text-white",
        style: {
            backgroundImage: "url(/img/photos/bg32.jpg)"
        },
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container py-14 py-md-17 text-center",
            children: [
                /*#__PURE__*/ _jsx("i", {
                    className: "icn-flower text-white fs-30 opacity-50"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row mt-3",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-9 col-xxl-8 mx-auto",
                        children: /*#__PURE__*/ _jsx(Carousel, {
                            navigation: false,
                            slidesPerView: 1,
                            className: "dots-light dots-closer",
                            children: testimonialList6.map(function(param) {
                                var id = param.id, name = param.name, review = param.review;
                                return /*#__PURE__*/ _jsxs("blockquote", {
                                    className: "border-0 fs-24 mb-0",
                                    children: [
                                        /*#__PURE__*/ _jsxs("p", {
                                            children: [
                                                "“",
                                                review,
                                                "”"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "blockquote-details justify-content-center",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "info p-0",
                                                children: /*#__PURE__*/ _jsx("h6", {
                                                    className: "mb-0 text-white",
                                                    children: name
                                                })
                                            })
                                        })
                                    ]
                                }, id);
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var testimonial_Testimonial18 = ((/* unused pure expression or super */ null && (Testimonial18)));

;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Testimonial19.tsx



// -------- data -------- //

var Testimonial19 = function() {
    return /*#__PURE__*/ _jsx("section", {
        id: "testimonials",
        children: /*#__PURE__*/ _jsx("div", {
            className: "wrapper image-wrapper bg-image bg-overlay",
            style: {
                backgroundImage: "url(/img/photos/bg35.jpg)"
            },
            children: /*#__PURE__*/ _jsxs("div", {
                className: "container pt-15 pb-13",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "display-5 mb-4 text-center text-white",
                        children: "Happy Customers"
                    }),
                    /*#__PURE__*/ _jsx(Carousel, {
                        spaceBetween: 0,
                        navigation: false,
                        breakpoints: carouselBreakpoints,
                        className: "dots-closer dots-light dots-light-75",
                        children: testimonialList7.map(function(param) {
                            var id = param.id, name = param.name, designation = param.designation, review = param.review;
                            return /*#__PURE__*/ _jsx("div", {
                                className: "item-inner",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card border-0 bg-white-900",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "card-body",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "ratings five mb-3"
                                            }),
                                            /*#__PURE__*/ _jsxs("blockquote", {
                                                className: "border-0 mb-0",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("p", {
                                                        children: [
                                                            "“",
                                                            review,
                                                            "”"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "blockquote-details",
                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                            className: "info p-0",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("h5", {
                                                                    className: "mb-0",
                                                                    children: name
                                                                }),
                                                                /*#__PURE__*/ _jsx("p", {
                                                                    className: "mb-0",
                                                                    children: designation
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }, id);
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var testimonial_Testimonial19 = ((/* unused pure expression or super */ null && (Testimonial19)));

// EXTERNAL MODULE: ./src/data/demo-26.ts + 4 modules
var demo_26 = __webpack_require__(88231);
;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Testimonial20.tsx


// -------- data -------- //

var Testimonial20 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "card bg-soft-primary mb-15 mb-md-17",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-body py-14 px-lg-0",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "row text-center",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-8 offset-lg-2",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "fs-16 text-uppercase text-primary mb-3",
                                children: "Happy Customers"
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-4 mb-10 px-xxl-10",
                                children: "Don't take our word for it. See what customers are saying about us."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row gx-lg-8 gx-xl-12 align-items-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-5 ms-auto col-xl-4 d-none d-lg-flex",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "img-mask mask-3",
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: "/img/photos/about31.jpg",
                                    srcSet: "/img/photos/about31@2x.jpg 2x",
                                    alt: ""
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-6 col-xl-6 col-xxl-5 me-auto",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "swiper-container",
                                children: /*#__PURE__*/ _jsx(Carousel, {
                                    spaceBetween: 0,
                                    navigation: false,
                                    slidesPerView: 1,
                                    className: "dots-start",
                                    children: data.testimonialList.map(function(param) {
                                        var id = param.id, name = param.name, designation = param.designation, review = param.review;
                                        return /*#__PURE__*/ _jsxs("div", {
                                            className: "mb-8",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "ratings five mb-3"
                                                }),
                                                /*#__PURE__*/ _jsxs("blockquote", {
                                                    className: "border-0 fs-lg mb-0",
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("p", {
                                                            children: [
                                                                "“",
                                                                review,
                                                                "”"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "blockquote-details",
                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                className: "info ps-0",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("h5", {
                                                                        className: "mb-1",
                                                                        children: name
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("p", {
                                                                        className: "mb-0",
                                                                        children: designation
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, id);
                                    })
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var testimonial_Testimonial20 = ((/* unused pure expression or super */ null && (Testimonial20)));

;// CONCATENATED MODULE: ./src/components/blocks/testimonial/Testimonial21.tsx

var Testimonial21 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "row position-relative mb-15 mb-md-17",
        children: [
            /*#__PURE__*/ _jsx("figure", {
                className: "rounded position-absolute d-none d-lg-block",
                style: {
                    top: "50%",
                    right: 0,
                    width: "45%",
                    height: "auto",
                    zIndex: 2,
                    transform: "translateY(-50%)"
                },
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/img/photos/tei1.jpg",
                    srcSet: "/img/photos/tei1@2x.jpg 2x",
                    alt: ""
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-lg-9 text-center",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "card bg-gray",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "card-body p-md-10 py-xxl-16",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "row gx-0",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "col-lg-8 ps-xl-10",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "ratings five fs-20 mb-3"
                                    }),
                                    /*#__PURE__*/ _jsxs("blockquote", {
                                        className: "border-0 fs-lg mb-0",
                                        children: [
                                            /*#__PURE__*/ _jsx("p", {
                                                children: "“Donec id elit non mi porta gravida at eget metus. Vivamus mollis est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Duis mollis porta est non commodo luctus.”"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "blockquote-details justify-content-center text-center",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "info p-0",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("h4", {
                                                            className: "ls-sm mb-1",
                                                            children: "Coriss Ambady"
                                                        }),
                                                        /*#__PURE__*/ _jsx("p", {
                                                            className: "mb-0",
                                                            children: "Financial Analyst"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var testimonial_Testimonial21 = ((/* unused pure expression or super */ null && (Testimonial21)));

;// CONCATENATED MODULE: ./src/components/blocks/testimonial/index.ts
























/***/ }),

/***/ 80959:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _opt_render_project_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_render_project_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_render_project_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var useIsotope = function() {
    var isotope = useRef();
    var ref = useState("*"), filterKey = ref[0], setFilterKey = ref[1];
    useEffect(function() {
        if (false) {}
        _async_to_generator(regeneratorRuntime.mark(function _callee() {
            var Isotope, grids;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return __webpack_require__.e(/* import() */ 3391).then(__webpack_require__.t.bind(__webpack_require__, 13391, 23));
                    case 2:
                        Isotope = _ctx.sent.default;
                        grids = document.querySelectorAll(".grid");
                        if (grids !== null) {
                            grids.forEach(function(g) {
                                var grid = g.querySelector(".isotope");
                                isotope.current = new Isotope(grid, {
                                    itemSelector: ".item",
                                    layoutMode: "masonry",
                                    masonry: {
                                        columnWidth: grid.offsetWidth / 12
                                    },
                                    percentPosition: true,
                                    transitionDuration: "0.7s"
                                });
                            });
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
        return function() {
            var ref;
            return (ref = isotope.current) === null || ref === void 0 ? void 0 : ref.destroy();
        };
    }, []);
    useEffect(function() {
        var ref;
        var filtered = filterKey === "*" ? {
            filter: "*"
        } : {
            filter: filterKey
        };
        (ref = isotope.current) === null || ref === void 0 ? void 0 : ref.arrange(filtered);
    }, [
        filterKey
    ]);
    // change filter item
    var handleFilterKeyChange = function(key) {
        return function() {
            return setFilterKey(key);
        };
    };
    return {
        handleFilterKeyChange: handleFilterKeyChange,
        filterKey: filterKey
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useIsotope)));


/***/ }),

/***/ 32783:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var carouselBreakpoints = {
    0: {
        slidesPerView: 1
    },
    768: {
        slidesPerView: 2
    },
    1200: {
        slidesPerView: 3
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (carouselBreakpoints);


/***/ })

}]);